import ahsanSajidImage from "@/assets/ahsan-sajid.png";
export const AiAgentsFounderQuote = () => (
  <div className="bg-card rounded-2xl border border-border p-6 sm:p-8">
    <div className="flex items-start gap-4">
      <img src={ahsanSajidImage} alt="Ahsan Sajid" className="w-14 h-14 rounded-full object-cover border-2 border-primary/20" />
      <div><blockquote className="text-foreground italic leading-relaxed">"The biggest lesson from building AI agents? Start with the workflow, not the technology. Ask: what manual process is costing the most time and money? Automate that first. The best AI agents solve real business problems, not hypothetical ones. And always have a fallback — because AI will fail at some point."</blockquote>
        <div className="mt-4"><p className="font-semibold text-foreground">Ahsan Sajid</p><p className="text-sm text-muted-foreground">Owner, IT Dukes</p></div>
      </div>
    </div>
  </div>
);
